import * as React from "react";
import { useState } from "react";
import { ISerializedUIField, IUIPropertyDefinitionMap, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common";
import WDFilterPanel from "../../../common/components/WDFilterPanel";
import { FieldContainer } from "../../../common/FieldContainer";
import { DataSourceProperty } from "../../../common/ui-props/DataSourceProperty";
import { createDefaultPropsForWidgetWrapperWithSidebar, WidgetWrapperWithSidebar } from "../../../common/widget-wrappers/WidgetWrapperWithSidebar";
import './object-widget.scss'
import { extractContextData, loadInitialData, replaceWithData } from "../../../../util";
import ActionButton from "../../../common/components/ActionButton";
import { generateIconPropAsSting } from "../../../common/icon-selector/IconEditor";
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem";
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty";
import { TextProperty, extractTextProperties } from "../../../common/ui-props/TextProperty";
import { WidgetWrapper } from "uxp/components";
import { useInitialContextData } from "../../../../hooks/useContextData";

const XPRProps: IUIPropertyDefinitionMap = {
    'container': ContainerProperty({
        background: {
            color: "#FFF",
            image: {
                image: "",
                position: "",
                size: "",
            },
        },
    }),
    'headerContainer': ContainerProperty({
        background: {
            color: "#5652C2",
            image: {
                image: "",
                position: "",
                size: "",
            },
        },
    }),

    'title': TextProperty({
        text: '',
        color: '#424242',
        size: '12px'
    }, 'Title'),

    'contentShared': TextProperty({
        text: '',
    }, 'Content Shared'), 
};


const XPR: React.FunctionComponent<IWidgetTemplateProps> = (props) => {

    let uiProps = props?.uiProps || {};

    const [loading, setLoading] = useState(false);
    const [contextData, setContextData] = useState<{ [key: string]: any }>({})
    const [disableDrop, setDisableDrop] = useState(false)

    const containerRef = React.useRef(null);

    const { isLoading, initialContextData } = useInitialContextData(props)

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    React.useEffect(() => {
        console.log('context_data_________', contextData)
    }, [contextData])

    React.useEffect(() => {
        console.log('DATA and FILTERS', contextData);

    }, [contextData])

    React.useEffect(() => {
        console.log("disableDrop", disableDrop)
    }, [disableDrop])

    React.useEffect(() => {
        updateHeight()
    }, [uiProps]);

    function updateHeight() {
        const container = containerRef.current as HTMLDivElement
        if (container) {
            if (props.updateWidgetHeight) {
                props.updateWidgetHeight(container.scrollHeight)
            }

        }
    }


    let { styles: containerStyles } = extractContainerProperties(uiProps.container);
    let { styles: headerStyles } = extractContainerProperties(uiProps.headerContainer);
    let { text: title, styles: titleStyles } = extractTextProperties(uiProps.title, '');
    let { text: contentShared } = extractTextProperties(uiProps.contentShared, '');

    title = replaceWithData(title, contextData)
    contentShared = replaceWithData(contentShared, contextData)

    return <WidgetWrapper className={"uxp-object-widget-template  "}  >

        <SelectableItem
            designer={props.designer}
            props={selectUIProps(uiProps, XPRProps, 'container', 'action')}
            elementId='container'
            contextData={contextData}
        >
            <div className="container" ref={containerRef}>

                <div className="header">
                    <SelectableItem
                        designer={props.designer}
                        props={selectUIProps(uiProps, XPRProps, 'headerContainer', 'title', 'contentShared')}
                        contextData={contextData}
                    >
                        <div className="uxp-widget-title-bar uxp-drag-handler" style={headerStyles}>
                            <div className="title-section" style={titleStyles}>
                                <span className="title-icon"></span>
                                <span className="txt">{title}</span>
                            </div>
                            <div className="action-section">
                                <div className='object-header-actions'>
                                    <ActionButton
                                        title={''}
                                        icon={generateIconPropAsSting('bookmark')}
                                        iconPosition={'left'}
                                        uxpContext={props?.uxpContext}
                                        action={null}
                                        contextData={contextData}
                                        styles={{}}
                                        iconStyles={{}}
                                        onReloadWidget={() => {
                                            if (uiProps.onReloadWidget) uiProps.onReloadWidget()
                                        }}
                                    />
                                    <ActionButton
                                        title={''}
                                        icon={generateIconPropAsSting('share')}
                                        iconPosition={'left'}
                                        uxpContext={props?.uxpContext}
                                        action={null}
                                        contextData={contextData}
                                        styles={{}}
                                        iconStyles={{}}
                                        onReloadWidget={() => {
                                            if (uiProps.onReloadWidget) uiProps.onReloadWidget()
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </SelectableItem>
                </div>

                <div className="body" style={containerStyles}>
                    <FieldContainer
                        designer={props.designer}
                        uxpContext={props.uxpContext}
                        contextData={contextData}
                        onChangeData={setContextData}
                        uiProps={uiProps}
                        disabled={disableDrop}
                    />

                </div>


            </div>
        </SelectableItem >
    </WidgetWrapper>;
};

registerCardTemplate({
    id: 'object-widget',
    name: 'Object View',
    description: 'Use this to show details about a specific item',
    template: XPR,
    canDragDropFields: true,
    icon: ['fas', 'credit-card-blank'],
    complexity: 'advanced',
    autoHieght: true
});